module.exports = __webpack_public_path__ + "img/public-login.4e97a86a.svg";